import helpers from '../helpers';
import articleScroll from './article-scroll';
import home from './home';
import matrix from './matrix';

const $preloader = $('.preloader');
const $elem1 = $preloader.find('.preloader__item--1');
const $progress = $preloader.find('.preloader__progress');

const finish = async () => {
	articleScroll.init();

	gsap.to($preloader, {
		onComplete() {
			gsap.killTweensOf($elem1);
			gsap.set($elem1, {clearProps: 'all'});

			// helpers.$document.trigger('bg-destroy', '.preloader__bg');

			$preloader.remove();

			helpers.$html.removeClass('is-lock-scroll');

			matrix.init();

			setTimeout(home.init, 50);
		},
		delay: 1,
		duration: 0.5,
		clearProps: true,
		autoAlpha: 0,
	});
};

const animateProgress = () => {
	return new Promise((resolve) => {
		let start = 0;

		let time = setInterval(() => {
			start++;

			$progress.html(`${start}%`);

			if (start === 100) {
				clearInterval(time);

				resolve();
			}
		}, 1000 / 60);
	});
};

const animateElem = () => {
	gsap.to($elem1, {
		delay: 0.25,
		duration: 1.5,
		ease: 'Sine.easeInOut',
		repeat: -1,
		yoyo: true,
		transformOrigin: '88% 57%',
		rotate: -25,
	});
};

const start = () => {
	return new Promise((resolve) => {
		animateElem();

		document.addEventListener('DOMContentLoaded', () => {
			animateProgress().then(resolve);
		});
	});
};

export default {
	start,
	finish,
};
